// extracted by mini-css-extract-plugin
export default {"goBackIcons":"package_plan_goBackIcons__dTDjA","picPlan":"package_plan_picPlan__4Yn4D"};